import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AppPage from "@/pages/AppPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PrivacyIndexPage from "@/pages/PrivacyIndexPage";
import SupportPage from "@/pages/SupportPage";
import BeyondPage from "@/pages/BeyondPage";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apps/:slug" element={<AppPage />} />
          <Route path="/privacy" element={<PrivacyIndexPage />} />
          <Route path="/privacy/:slug" element={<PrivacyPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/oltre" element={<BeyondPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="bottom-center" theme="dark" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
